import { Component } from '@angular/core';
import { BtnGroupNavComponent } from '../../../utils/btn-group-nav/btn-group-nav.component';

import { SpinnerComponent } from '../../../utils/spinner/spinner.component';
import { Router, RouterOutlet } from '@angular/router';
import { LocationService } from '../../../../services/resources/location.service';
import { AConcreteResource } from '../../../AConcreteResource';
import { LocationModel } from '../../../../models/resources/location.model';
import {SubPageModel} from "../../../../models/sub-page.model";

@Component({
  selector: 'app-location',
  imports: [
    BtnGroupNavComponent,
    SpinnerComponent,
    RouterOutlet
  ],
  templateUrl: './location.component.html',
  styleUrl: './location.component.scss',
})
export class LocationComponent extends AConcreteResource<LocationModel> {
  pages: SubPageModel[] = [
    {
      value: 'DATA',
      link: '.',
      isBasePage: true,
      icon: 'fas fa-info-circle'
    },
    {
      value: 'NAVIGATION.VEHICLES',
      link: 'vehicles',
      icon: 'fas fa-car'
    },
  ];
  activePage: SubPageModel = this.pages[0];

  constructor(
    router: Router,
    locationService: LocationService
  ) {
    super(router, locationService);
  }
}
